import { ScreenInsightsTime } from '@dms/screen'

// export { getServerSideProps } from '@dms/screen/insights'

export default ScreenInsightsTime
